 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFRONTMATTER01 from '@/components/xhtml/frontmatter01'
 import XHTMLFRONTMATTER02 from '@/components/xhtml/frontmatter02'
 import XHTMLFRONTMATTER03 from '@/components/xhtml/frontmatter03'
 import XHTMLHALFTITLE01 from '@/components/xhtml/halftitle01'
 import XHTMLCHAPTER01 from '@/components/xhtml/chapter01'
 import XHTMLCHAPTER02 from '@/components/xhtml/chapter02'
 import XHTMLCHAPTER03 from '@/components/xhtml/chapter03'
 import XHTMLCHAPTER04 from '@/components/xhtml/chapter04'
 import XHTMLCHAPTER05 from '@/components/xhtml/chapter05'
 import XHTMLCHAPTER06 from '@/components/xhtml/chapter06'
 import XHTMLBACKMATTER01 from '@/components/xhtml/backmatter01'
 import XHTMLBACKMATTER02 from '@/components/xhtml/backmatter02'
 import XHTMLBACKMATTER03 from '@/components/xhtml/backmatter03'
 import XHTMLBACKMATTER04 from '@/components/xhtml/backmatter04'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/frontmatter01",
 			"name" : "xhtml/frontmatter01",
 			"component" : XHTMLFRONTMATTER01
 		},
 		{
 			"path" : "/xhtml/frontmatter02",
 			"name" : "xhtml/frontmatter02",
 			"component" : XHTMLFRONTMATTER02
 		},
 		{
 			"path" : "/xhtml/frontmatter03",
 			"name" : "xhtml/frontmatter03",
 			"component" : XHTMLFRONTMATTER03
 		},
 		{
 			"path" : "/xhtml/halftitle01",
 			"name" : "xhtml/halftitle01",
 			"component" : XHTMLHALFTITLE01
 		},
 		{
 			"path" : "/xhtml/chapter01",
 			"name" : "xhtml/chapter01",
 			"component" : XHTMLCHAPTER01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js